// extracted by mini-css-extract-plugin
export default {"cartBody":"cart_cartBody__WNEJ2","sheetBody":"cart_sheetBody__31Qj9","cartItemImg":"cart_cartItemImg__HegO0"};